import React from 'react';
import { Box, Typography } from '@mui/material';

import { ELIG_TOKENS } from '../theme/readinessTokens';

import { Field } from './EligibilityBenefitsView';

interface Props {
  /** The member ID the check sent, if any. */
  memberId?: string | null;
  /** The ID the payer lists, when it differs from ours beyond case, spaces and dashes. */
  payerListedId?: string | null;
  /** The payer's ID names another member, not ours with a person code. */
  anotherMember: boolean;
}

/**
 * Our member ID, with the ID the payer lists when it differs (GDN-4265).
 * A person code for the same member is informational; another member's ID
 * is a warning, and the check's alert asks for the right ID. Without our
 * ID, the payer's still shows, on its own line.
 */
export const MemberIdField: React.FC<Props> = ({ memberId, payerListedId, anotherMember }) => (
  <Box>
    <Field label="Member ID" value={memberId || '—'} />
    {payerListedId && payerListedId !== memberId && (
      <Typography
        variant="caption"
        sx={{
          display: 'block',
          textAlign: 'right',
          color: anotherMember ? ELIG_TOKENS.amber : ELIG_TOKENS.inkSoft,
        }}
      >
        Payer lists {payerListedId}
      </Typography>
    )}
  </Box>
);
